import apiAgentGroups from '../axios/apiAgentGroupsInstance';

const authHeader = (token) => ({ Authorization: `Bearer ${token}` });

export const getAgentGroups = async ({ id_customer, token, skip = 0, limit = 50 }) => {
  if (!id_customer) throw new Error('id_customer is required');
  if (!token) throw new Error('token is required');
  const { data } = await apiAgentGroups.get(`/customer/${id_customer}`, {
    params: { skip, limit },
    headers: authHeader(token),
  });
  return Array.isArray(data) ? data : [];
};

export const getAgentGroupById = async ({ group_id, token }) => {
  if (!group_id) throw new Error('group_id is required');
  if (!token) throw new Error('token is required');
  const { data } = await apiAgentGroups.get(`/${group_id}`, {
    headers: authHeader(token),
  });
  return data;
};

export const createAgentGroup = async ({ name, description, id_customer, token }) => {
  if (!name) throw new Error('name is required');
  if (!id_customer) throw new Error('id_customer is required');
  if (!token) throw new Error('token is required');
  const body = { name, id_customer };
  if (description) body.description = description;
  const { data } = await apiAgentGroups.post('/', body, {
    headers: authHeader(token),
  });
  return data;
};

export const updateAgentGroup = async ({ group_id, name, description, token }) => {
  if (!group_id) throw new Error('group_id is required');
  if (!token) throw new Error('token is required');
  const body = {};
  if (name !== undefined) body.name = name;
  if (description !== undefined) body.description = description;
  const { data } = await apiAgentGroups.patch(`/${group_id}`, body, {
    headers: authHeader(token),
  });
  return data;
};

export const deleteAgentGroup = async ({ group_id, token }) => {
  if (!group_id) throw new Error('group_id is required');
  if (!token) throw new Error('token is required');
  await apiAgentGroups.delete(`/${group_id}`, { headers: authHeader(token) });
};

export const addGroupMembers = async ({ group_id, agent_ids, token }) => {
  if (!group_id) throw new Error('group_id is required');
  if (!agent_ids?.length) throw new Error('agent_ids is required');
  if (!token) throw new Error('token is required');
  const { data } = await apiAgentGroups.post(`/${group_id}/members`, { agent_ids }, {
    headers: authHeader(token),
  });
  return data;
};

export const removeGroupMember = async ({ group_id, agent_id, token }) => {
  if (!group_id) throw new Error('group_id is required');
  if (!agent_id) throw new Error('agent_id is required');
  if (!token) throw new Error('token is required');
  await apiAgentGroups.delete(`/${group_id}/members/${agent_id}`, {
    headers: authHeader(token),
  });
};

export const getAgentGroupsByAgentId = async ({ agent_id, token }) => {
  if (!agent_id) throw new Error('agent_id is required');
  if (!token) throw new Error('token is required');
  const { data } = await apiAgentGroups.get(`/agent/${agent_id}`, {
    headers: authHeader(token),
  });
  return Array.isArray(data) ? data : [];
};

export const getAgentsByGroups = async ({ id_customer, group_ids, offset = 0, limit = 10, token }) => {
  if (!id_customer) throw new Error('id_customer is required');
  if (!group_ids?.length) throw new Error('group_ids is required');
  if (!token) throw new Error('token is required');
  const { data } = await apiAgentGroups.get(`/agents/${id_customer}`, {
    params: { group_ids, offset, limit },
    paramsSerializer: (params) => {
      const sp = new URLSearchParams();
      (params.group_ids || []).forEach((id) => sp.append('group_ids', id));
      sp.append('offset', params.offset ?? 0);
      sp.append('limit', params.limit ?? 10);
      return sp.toString();
    },
    headers: authHeader(token),
  });
  return data;
};